import { render, staticRenderFns } from "./CockpitHeader.vue?vue&type=template&id=503fd2f7&scoped=true"
import script from "./CockpitHeader.vue?vue&type=script&lang=js"
export * from "./CockpitHeader.vue?vue&type=script&lang=js"
import style0 from "./CockpitHeader.vue?vue&type=style&index=0&id=503fd2f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503fd2f7",
  null
  
)

export default component.exports